import { INewbuilding } from '../../types/newbuilding/newbuilding';
import { EFavoritesActionTypes, IFavoritesAction } from '../../actions/favorite';
import { TReduxActions } from '../../types/redux';

const defaultState = {
  newbuildingPath: '',
  banks: [],
  breadcrumbs: [],
  builders: [],
  description: '',
  displayName: '',
  gaLabel: '',
  geo: {
    regionId: 0,
    timezone: 0,
  },
  id: 0,
  isFavorite: false,
  isReliableV2: false,
  name: '',
  promoInfos: [],
  sellers: [],
  seoDescription: '',
  seoKeywords: '',
  seoLinks: [],
  seoTitle: '',
  specifications: [],
  stats: {
    fromDeveloperMaxPrice: 0,
    fromDeveloperMinPrice: 0,
  },
};

export function newbuildingReducer(state: INewbuilding = defaultState, action: TReduxActions) {
  switch (action.type) {
    case EFavoritesActionTypes.SetIsFavorite:
      return {
        ...state,
        ...(action as IFavoritesAction).payload,
      };
    default:
      return state;
  }
}
